export default {
  sports (state) {
    return {
      ...state,
      storeName: 'sports'
    }
  }
}
